// extracted by mini-css-extract-plugin
export default {"root":"Select_root__0i90G","svg":"Select_svg__vMl1e","dropdown":"Select_dropdown__crq-m","option":"Select_option__j+t6g"};